import request from '@/utils/request'
const serivceBase = require('@/config/serviceConfig')

// 兑换码同步兑换
export function citicExchange(data) {
  return request({
    url: `${serivceBase.IMS}/redeemCodeStream/syncVerify`,
    method: 'post',
    data
  })
}
// 发送短信
export function citicSendCode(data) {
  return request({
    url: `${serivceBase.IMS}/redeemCodeStream/sendVerifyCodeForSync`,
    method: 'post',
    data
  })
}
// 二次进入获取兑换手机号
export function citicGetPhone(data) {
  return request({
    url: `${serivceBase.IMS}/redeemCodeStream/getExchangePhone`,
    method: 'post',
    data
  })
}
// 同步兑换码列表查询
export function citicListRedeem(data) {
  return request({
    url: `${serivceBase.IMS}/redeemCodeStream/listRedeemCodeForSyncWithDescribe`,
    method: 'post',
    data
  })
}

// 套餐同步兑换码列表查询
export function citicPackageListRedeem(data) {
  return request({
    url: `${serivceBase.IMS}/redeemCodeStream/listRedeemCodeWithDescribe`,
    method: 'post',
    data
  })
}

// 获取微信签名
export function citicGetWxSign(data) {
  return request({
    url: `${serivceBase.IMS}/redeemCodeStream/getWxSign`,
    method: 'post',
    data
  })
}
